import {Routes} from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {permissions} from '../../permissions';
import {AuthGuardService as AuthGuard} from '../../auth-guard.service';
import {ZeroOutInventoryComponent} from './zero-out-inventory.component';

export const routes: Routes = [{
  path: 'zero-out-inventory',
  component: ZeroOutInventoryComponent,
  canActivate: [AuthGuard, NgxPermissionsGuard],
  data: {
    title: 'Zero Out Inventory',
    permissions: {
      only: []
    }
  },
}];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/zero-out-inventory/zero-out-inventory.routing.ts